<div class="scripts-history-table-container">
  @if (scriptId && isHistoryTableInit) {
    <cpq-datatable #datatable [service]='scriptHistoryService' [columns]="columns"
      [filter]='filter' [showFilter]="false" (onRowChanged)="onRowChanged($event)" [guid]="guid" [rowIdentifier]="'versionNumber'">
    </cpq-datatable>
  }
  <ng-template #editTmpl let-column="column" let-row='row'>
    @if (!row.isSystem) {
      <button class="fiori3-icon-button" (click)="showDetails(row.id, row.versionNumber)" title="{{'Msg.View' | translate}}">&#xe1e9;</button>
    }
  </ng-template>
  <ng-template #buttonHeader let-column="column" let-row='row'>
    @if (scriptId && isHistoryTableInit) {
      <button type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="compare()" id="compareScripts">{{'Admin.Responsive.Compare' | translate}}</button>
    }
  </ng-template>
</div>

